import React, { Component } from 'react';
import { NavLink } from 'react-router-dom';
import Sidebar from '../../Components/Sidebar';
import Btn from '../../Components/Btn';
import CitiesTable from './Components/CitiesTable';

export default class Cities extends Component {
  render() {
    return (
      <div className="wrapper">
        <Sidebar/>
        <div className="main-panel">
          <div className="page-title">
            <div className="page-title-heading">
              <h1>Cities</h1>
              <Btn className="btn simple"><NavLink to="/new-city">add city</NavLink></Btn>
            </div>
          </div>
          
          <div className="table-responsive">
            <CitiesTable/>
          </div>
        </div>
      </div>
    );
  }
}
